module.exports = __webpack_public_path__ + "img/horror.6624e82d.png";